<template>
    <div>
        <div class="row">
            <div class="col-md-6">
                <h5>Change your account settings</h5>
                <b-form>
                    <b-form-group
                            id="input-group-1"
                            label="Screen Idle Timeout:"
                            label-for="input-1"
                            description="When the site is open and you are idle the screen will blur for PHI/PII security reasons"
                    >
                        <b-form-select
                                id="input-1"
                                required
                                :options="idleOptions"
                                v-model="screenIdle"
                                @change="setIdleTimeout"
                        ></b-form-select>
                    </b-form-group>
                    <b-form-group
                            id="input-group-1"
                            label="Logout Timeout:"
                            label-for="input-1"
                            description="When the site is idle a countdown till logout will start"
                    >
                        <b-form-select
                                id="input-1"
                                required
                                :options="logoutOptions"
                                v-model="logoutTimeout"
                                @change="setLogoutTimeout"
                        ></b-form-select>
                    </b-form-group>
                    <b-button to="/dashboard/producer" variant="primary">Done</b-button>
                </b-form>
            </div>
        </div>
    </div>
</template>

<script>
    import config from '@/config/config'
    import { userPreferences } from '@/config/config'

    export default {
        name: 'Preferences',
        data() {
            return {
                screenIdle: 0,
                logoutTimeout: 0,
            }
        },
        computed: {
            idleOptions () {
                return config.getProfileDefaults().idleTimeoutOptions
            },
            logoutOptions () {
                return config.getProfileDefaults().logoutTimeoutOptions
            }
        },
        methods: {
            setIdleTimeout () {
                localStorage.setItem('screenIdle', this.screenIdle)
            },
            setLogoutTimeout () {
                localStorage.setItem('logoutTimeout', this.logoutTimeout)
            },
            getScreenIdle () {
                this.screenIdle = userPreferences.screenIdle
            },
            getLogoutTimeout () {
                this.logoutTimeout = userPreferences.logoutTimeout
            }
        },
        beforeMount () {
            this.getScreenIdle()
            this.getLogoutTimeout()
        }
    }
</script>

<style scoped>

</style>
